import {history} from '../store/index';
import {store} from '../../NextApp';
import {message} from 'antd';
import {generateQueryString} from "../../util/Api";

import {CREATE_USER_SUCCESS, FETCH_USER_SUCCESS, GET_USER_SUCCESS, SAVE_USER_QUERY} from "../../constants/ActionTypes";

import axios from 'util/Api'
import {fetchError, fetchStart, fetchSuccess} from "./Common";
import {arrayToCSV, downloadCSV} from "../../util/methods";


export const getResourceSuccess = ({data, count}) => {
  return {
    type: GET_USER_SUCCESS,
    data,
    count
  };
};

export const saveResourceQuery = (query) => {
  return {
    type: SAVE_USER_QUERY,
    query
  };
};

export const createResourceSuccess = ({data}) => {
  return {
    type: CREATE_USER_SUCCESS,
    data
  };
};

export const fetchResourceSuccess = ({data}) => {
  return {
    type: FETCH_USER_SUCCESS,
    data
  };
};


export const getResource = () => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const {user} = store.getState();
      const {query} = user;
      const response = await axios.get(`/user?${generateQueryString(query)}`);
      dispatch(fetchSuccess());
      dispatch(getResourceSuccess(response.data));
    } catch (error) {
      message.error(error.response.data.message);
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const getResourceForDownload = (columns, filters, name) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const {user} = store.getState();
      const {query} = user;
      const response = await axios.get(`/user/download?columns=${columns}&${generateQueryString(query)}`);
      dispatch(fetchSuccess());
      const str = arrayToCSV(response.data, filters, columns)
      downloadCSV(str, name);
    } catch (error) {
      message.error(error.response.data.message);
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const createResource = (payload) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const response = await axios.post(`/user`, payload);
      dispatch(fetchSuccess());
      dispatch(createResourceSuccess({data: response.data}));
      history.push('/user');
      dispatch(getResource());
    } catch (error) {
      dispatch(fetchError(error));
      console.log("Error****:", error);
    }
  }
};

export const updateResource = (payload, id) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      await axios.put(`/user/${id}`, payload);
      dispatch(fetchSuccess());
      history.push('/user');
      dispatch(getResource());
    } catch (error) {
      console.log("Error****:", error);
      dispatch(fetchError(error.response.data.message));
    }
  }
};


export const fetchResource = (id) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const response = await axios.get(`/user/${id}`);
      dispatch(fetchSuccess());
      dispatch(fetchResourceSuccess({data: response.data}));
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const deleteResource = (id) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      await axios.delete(`/user/${id}`);
      dispatch(fetchSuccess());
      dispatch(getResource());
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};
